export default __webpack_public_path__ + "static/media/IndiaSoft2025-Skyniche 3 1-18.b8f83fe0.png";